"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
(0, tslib_1.__exportStar)(require("./getAppletsOpenId"), exports);
(0, tslib_1.__exportStar)(require("./wechatAppletsLogin"), exports);
(0, tslib_1.__exportStar)(require("./wechatAppletsLoginOut"), exports);
(0, tslib_1.__exportStar)(require("./wechatAppletsLoginWithMobile"), exports);
(0, tslib_1.__exportStar)(require("./getPhoneDynamicCodeForApplets"), exports);
//# sourceMappingURL=index.js.map